import { render, staticRenderFns } from "./dragableComponents.vue?vue&type=template&id=46211fae&"
import script from "./dragableComponents.vue?vue&type=script&lang=js&"
export * from "./dragableComponents.vue?vue&type=script&lang=js&"
import style0 from "./dragableComponents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports